const initialState = {
	yearBuilt: '',
	lotSize: '',
	baths: '',
	bathsAll:'',
	halfBath: '',
	bedrooms: '',
	garageBays: '',
	sqft: {
		type: '',
		value: 0,
		from: 0,
		to: 0
	},
	price: {
		type: '',
		value: 0,
		from: 0,
		to: 0
	},
};
const hero = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state
	}
}

export default hero;
